var modules_5f96f03e = {"container":"Switch_module_container__ea4ae8dc","checked":"Switch_module_checked__ea4ae8dc","control":"Switch_module_control__ea4ae8dc","disabled":"Switch_module_disabled__ea4ae8dc","read-only":"Switch_module_readOnly__ea4ae8dc","input":"Switch_module_input__ea4ae8dc","handler":"Switch_module_handler__ea4ae8dc","label":"Switch_module_label__ea4ae8dc"};
import "../../../assets/esm/components/Switch/src/Switch~Ct5MJcME.css";

export { modules_5f96f03e as default };
//# sourceMappingURL=Switch.module.less.js.map
